import createHistory from 'history/createBrowserHistory';
import { RouterStore, syncHistoryWithStore } from '../mobx-react-router';

const browserHistory = createHistory();
export const routingStore = new RouterStore();
export const history = syncHistoryWithStore(browserHistory, routingStore);
